import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { Storage } from '@ionic/storage';
import { AngularFireDatabaseWrapper } from '../../../../providers/angularfire-wrapper';



@Component({
	selector: 'page-coupons-full',
	templateUrl: 'coupons.full.html'
})
export class CouponsPageFull extends PageBaseFull {
	public loader: any;
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public storage: Storage,
		public afw: AngularFireDatabaseWrapper,
		public loadingCtrl: LoadingController,
		private navParams: NavParams
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();

	}
	ngAfterViewInit() {
		//this.common.commonMethod();
	}

	ionViewDidEnter() {
	}
	
}



// WEBPACK FOOTER //
// ./src/modules/coupons/pages/coupons/coupons.full.ts